module.exports = __webpack_public_path__ + "static/media/Bumblebee Girl.83d561a9.jpg";